var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import PrimaryButton from "../Button/PrimaryButton";
// import ImageThumbnail from "../ImageThumbnail";
// import images from "../../utils/Images";
import { ToastContainer, toast } from "react-toastify";
import useAddNameToList from "../../hooks/useAddNameToList";
import Spinner from "../Spinner";
import { useDispatch, useSelector } from "react-redux";
import useAddTimeLog from "../../hooks/useAddTimeLog";
import useFetchShipNames from "../../hooks/useFetchShipNames";
import useFetchHeaderNames from "../../hooks/useFetchHeaderNames";
import TimeSelector from "../TimeSelector";
import { reloadTimeLogs } from "../../store/slices/reloadSlice";
import images from "../../utils/Images";
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import useVoiceInput from "../../hooks/useVoiceInput";
var AddTimeLogs = function (_a) {
    var closeModal = _a.closeModal, positions = _a.positions, addLogHandle = _a.addLogHandle, date = _a.date, editData = _a.editData;
    var modalRef = useRef(null);
    var dispatch = useDispatch();
    var _b = React.useState(false), showConfirm = _b[0], setShowConfirm = _b[1];
    var _c = React.useState(0), didSkip = _c[0], setDidSkip = _c[1];
    var _d = React.useState([]), exemptedLunchBreaks = _d[0], setExemptedLunchBreaks = _d[1];
    var _e = React.useState((editData === null || editData === void 0 ? void 0 : editData.selectedPosition) || 0), selectedPosition = _e[0], setSelectedPositions = _e[1];
    var _f = React.useState(date), dateSelected = _f[0], setDateSelected = _f[1];
    var _g = React.useState(""), startTime = _g[0], setStartTime = _g[1];
    var _h = React.useState(""), endTime = _h[0], setEndTime = _h[1];
    var _j = React.useState(""), vesselName = _j[0], setVesselName = _j[1];
    var _k = React.useState(""), shipName = _k[0], setShipName = _k[1];
    var _l = React.useState(""), headerName = _l[0], setHeaderName = _l[1];
    var _m = React.useState([]), vesselSuggestions = _m[0], setvesselSuggestions = _m[1];
    var _o = React.useState([]), shipSuggestions = _o[0], setShipSuggestions = _o[1];
    var _p = React.useState([]), headerSuggestions = _p[0], setHeaderSuggestions = _p[1];
    var profileId = useSelector(function (state) { var _a; return (_a = state.profile.profile) === null || _a === void 0 ? void 0 : _a.id; });
    var _q = useState([]), selectedBreaks = _q[0], setSelectedBreaks = _q[1];
    var _r = React.useState(false), showvesselSuggestions = _r[0], setShowvesselSuggestions = _r[1];
    var _s = React.useState(false), showShipSuggestions = _s[0], setShowShipSuggestions = _s[1];
    var _t = React.useState(false), showHeaderSuggestions = _t[0], setShowHeaderSuggestions = _t[1];
    var _u = React.useState(true), showShip = _u[0], setShowShip = _u[1];
    var _v = useAddTimeLog(), timeLogLoading = _v.loading, addTimeLog = _v.addTimeLog, getLunchBreaks = _v.getLunchBreaks;
    var _w = useFetchShipNames(), vesselNames = _w.vesselNames, shipNames = _w.shipNames, getShipNames = _w.getShipNames, error = _w.error, shipNamesLoading = _w.loading;
    var _x = useFetchHeaderNames(), headerNames = _x.headerNames, getHeaderNames = _x.getHeaderNames, headerNameError = _x.error;
    useEffect(function () {
        if (editData) {
            console.log(editData, "edit data in useeffect");
            setSelectedPositions(editData.selectedPosition.toString());
            setDateSelected(editData.dateSelected);
            setStartTime(editData.startTime);
            setEndTime(editData.endTime);
            setVesselName(editData.vesselName);
            setShipName(editData.shipName);
            setHeaderName(editData.headerName);
            setSelectedBreaks(editData.selectedBreaks);
            fetchLunchBreaks();
            if (editData.selectedBreaks.length > 0) {
                setShowConfirm(true);
                setDidSkip(2);
            }
        }
    }, [editData]);
    var getShipNameOptions = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getShipNames()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (error)
            toast.error(error);
    }, [error]);
    var getHeaderNameOptions = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getHeaderNames()];
                case 1:
                    _a.sent();
                    if (headerNameError) {
                        toast.error(headerNameError);
                    }
                    if (editData) {
                        setSelectedPositions(editData.selectedPosition);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getShipNameOptions();
        getHeaderNameOptions();
    }, []);
    useEffect(function () {
        if (vesselNames.length > 0) {
            setvesselSuggestions(vesselNames);
        }
        if (headerNames.length > 0) {
            setHeaderSuggestions(headerNames);
        }
        if (shipNames.length > 0) {
            setShipSuggestions(shipNames);
        }
    }, [vesselNames, shipNames, headerNames]);
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (modalRef.current &&
                !modalRef.current.contains(event.target)) {
                closeModal();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [closeModal]);
    var closeModalHandle = function () {
        closeModal();
    };
    var fetchLunchBreaks = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = {
                        start_time: (editData && editData.startTime) ? editData.startTime : startTime,
                        vessel_name: (editData && editData.vesselName) ? editData.vesselName : vesselName,
                    };
                    return [4 /*yield*/, getLunchBreaks(payload)];
                case 1:
                    result = _a.sent();
                    if (result.status === "success") {
                        setExemptedLunchBreaks(result.lunch_breaks);
                        return [2 /*return*/, result.lunch_breaks];
                    }
                    else if (result.status == "failed") {
                        toast.error(result.message);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var chooseAddAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isValidated, lunchBreaks;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isValidated = validateTimeInputs();
                    if (!isValidated)
                        return [2 /*return*/];
                    return [4 /*yield*/, fetchLunchBreaks()];
                case 1:
                    lunchBreaks = _a.sent();
                    if (!(lunchBreaks.length > 0 && didSkip == 0)) return [3 /*break*/, 2];
                    setShowConfirm(true);
                    return [3 /*break*/, 4];
                case 2: 
                // proceed to add log
                return [4 /*yield*/, addLogAction()];
                case 3:
                    // proceed to add log
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var validateTimeInputs = function () {
        if (selectedPosition === 0) {
            toast.error("Please select a position");
            return false;
        }
        if (dateSelected == "") {
            toast.error("Please select a date");
            return false;
        }
        if (startTime == "") {
            toast.error("Please select a start time");
            return false;
        }
        if (endTime == "") {
            toast.error("Please select an end time");
            return false;
        }
        if (vesselName == "") {
            toast.error("Please Select Vessel Name");
            return false;
        }
        if (showShip)
            if (shipName == "") {
                toast.error("Please Select Ship Name");
                return false;
            }
        if (headerName == "") {
            toast.error("Please Enter Header Name");
            return false;
        }
        return true;
    };
    var addLogAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log({
                        selected_position: selectedPosition,
                        date: dateSelected,
                        start_time: startTime,
                        end_time: endTime,
                        vessel_name: vesselName,
                        ship_name: shipName,
                        header_name: headerName,
                        editData: editData
                    }, "payload checking");
                    payload = {
                        selected_position: selectedPosition,
                        date: dateSelected,
                        start_time: startTime,
                        end_time: endTime,
                        vessel_name: vesselName,
                        ship_name: shipName,
                        header_name: headerName,
                        // user_id: 123,
                        isEdit: false,
                        uuid: editData ? editData.uuid : null,
                        selectedBreaks: selectedBreaks
                    };
                    return [4 /*yield*/, addTimeLog(payload)];
                case 1:
                    result = _a.sent();
                    if (result.status === "success") {
                        toast.success(result.message);
                        addLogHandle();
                        dispatch(reloadTimeLogs());
                    }
                    else if (result.status == "failed") {
                        toast.error(result.message);
                    }
                    else {
                        toast.error("An unexpected error occurred." + (result.error ? " Details: ".concat(result.error) : ''));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleVesselChange = function (value) {
        var isValid = vesselSuggestions.some(function (v) { return v.toLowerCase() === value.trim().toLowerCase(); });
        if (!isValid) {
            setVesselName("");
            return;
        }
        setShowvesselSuggestions(false);
        setVesselName(value);
        setShowvesselSuggestions(value.length > 0 &&
            !vesselSuggestions.some(function (vessel) { return vessel.toLowerCase() === value.toLowerCase(); }));
    };
    var handleShipNameChange = function (value) {
        setShipName(value);
        setShowShipSuggestions(value.length > 0 &&
            !shipSuggestions.some(function (ship) { return ship.toLowerCase() === value.toLowerCase(); }));
    };
    var handleHeaderNameChange = function (value) {
        setHeaderName(value);
        setShowHeaderSuggestions(value.length > 0 &&
            !headerSuggestions.some(function (header) {
                return header.toLowerCase() === value.toLowerCase();
            }));
    };
    var selectVesselSuggestion = function (suggestion) {
        setVesselName(suggestion);
        if (suggestion.trim() == 'YARD') {
            setShowShip(false);
        }
        else {
            setShowShip(true);
        }
        setShowvesselSuggestions(false);
    };
    var selectShipSuggestion = function (suggestion) {
        setShipName(suggestion);
        setShowShipSuggestions(false);
    };
    var selectHeaderSuggestion = function (suggestion) {
        setHeaderName(suggestion);
        setShowHeaderSuggestions(false);
    };
    var loading = useAddNameToList().loading;
    var voice = useVoiceInput({
        positions: positions,
        vesselOptions: vesselSuggestions,
        shipOptions: shipSuggestions,
        headerOptions: headerSuggestions,
        onSetPosition: function (val) { return setSelectedPositions(val); },
        onSetDate: function (val) { return setDateSelected(val); },
        onSetStartTime: function (val) { return setStartTime(val); },
        onSetEndTime: function (val) { return setEndTime(val); },
        onSetVessel: function (val) { return setVesselName(val); },
        onSetShip: function (val) { return setShipName(val); },
        onSetHeader: function (val) { return setHeaderName(val); },
        onShowShip: function (show) { return setShowShip(show); },
    });
    var handleStartTimeChange = function (time) {
        // if (endTime && time > endTime)
        // {
        //     toast.error("Start time can not be after end time");
        //     setStartTime("");
        //     return;
        // }
        setStartTime(time);
    };
    var handleEndTimeChange = function (time) {
        // if (startTime && time < startTime)
        // {
        //     toast.error("End time can not be before start time");
        //     setEndTime("");
        //     return;
        // }
        setEndTime(time);
    };
    // Handle checkbox toggle
    var handleCheckboxChange = function (breakName) {
        setSelectedBreaks(function (prev) {
            return prev.includes(breakName)
                ? prev.filter(function (b) { return b !== breakName; }) // uncheck
                : __spreadArray(__spreadArray([], prev, true), [breakName], false);
        } // check
        );
    };
    var confirmComponent = function () {
        if (showConfirm)
            return (_jsxs(_Fragment, { children: [_jsx("div", { className: "mt-2", children: _jsx("h3", { className: "text-left text-[18px] font-semibold", children: "Did you work the meal hour?" }) }), _jsx("div", { className: "my-4 ", children: _jsxs("div", { className: "flex col space-x-4", children: [_jsxs("div", { className: "", onClick: function () { return setDidSkip(2); }, children: [_jsx("input", { checked: didSkip == 2, type: "radio", name: "skipBreak", value: "Yes" }), "\u00A0Yes"] }), _jsxs("div", { className: "", onClick: function () { return setDidSkip(1); }, children: [_jsx("input", { checked: didSkip == 1, type: "radio", name: "skipBreak", value: "No" }), "\u00A0No"] })] }) }), didSkip === 2 && (_jsx("div", { className: "my-4", children: _jsxs("div", { className: "flex flex-col justify-between bg-white shadow-sm rounded-lg py-2 text-sm text-gray-700", children: [_jsx("h3", { className: "text-left text-[18px] font-semibold", children: "Which meal breaks did you work on?" }), exemptedLunchBreaks.map(function (breaks, idx) { return (_jsxs("label", { className: "flex items-center space-x-2 py-2", children: [_jsx("input", { type: "checkbox", name: "selectedBreaks", checked: selectedBreaks.includes(breaks), onChange: function () { return handleCheckboxChange(breaks); }, className: "cursor-pointer" }), _jsx("span", { children: breaks })] }, idx)); })] }) }))] }));
        else
            return _jsx(_Fragment, {});
    };
    var setVesselNameHandle = function (name) {
        setVesselName(name);
    };
    return (_jsxs("div", { ref: modalRef, className: "absolute flex-1 top-5 right-0 left-0 z-10 justify-center px-1 overflow-y-auto", children: [_jsx(ToastContainer, { position: "top-right" }), _jsxs("div", { className: "bg-white my-12 relative w-full lg:w-[40%] lg:mx-auto rounded-xl border-[#00000014] outline-none p-4 opacity-100 shadow-[0_8px_12px_0_rgba(47,43,67,0.2)] border-t-[1px] border-t-[rgba(47,43,67,0.1)]", children: [_jsx("button", { onClick: function () { return closeModalHandle(); }, className: "absolute top-[-22px] right-[2px]", children: _jsx("img", { src: images.closeIcon, alt: "", style: { height: '50px' } }) }), _jsx("div", { className: "mt-2", children: _jsxs("h3", { className: "text-left text-[20px] font-semibold", children: [_jsxs("span", { className: "blue-text-color", children: [!editData ? "Add" : "Edit", " Time"] }), " ", _jsx("span", { className: "green-text-color", children: "Log." })] }) }), _jsx("div", { className: "my-1 ", children: _jsx("div", { className: "mt-2", children: _jsxs("select", { className: "w-full py-4 px-2 border border-[#C0CADA] outline-none rounded-md  text-[16px] dock-select-ui", onChange: function (e) {
                                    setSelectedPositions(e.target.value);
                                }, value: selectedPosition, children: [_jsx("option", { value: 0, disabled: true, className: "text-[#C0CADA]", children: "Select Position" }), positions.map(function (position, index) {
                                        return (_jsx("option", { value: position.id, className: "blue-text-color", children: position.position }, index));
                                    })] }) }) }), _jsxs("div", { className: "my-4", children: [_jsx("input", { type: "date", id: "date", className: "w-full py-4 px-2 border border-[#C0CADA] outline-none rounded-md  text-[16px] custom-date-input", placeholder: "Select Date", onClick: function (e) {
                                    var input = e.target;
                                    input.showPicker && input.showPicker();
                                }, style: { paddingRight: '30px' }, value: dateSelected, onChange: function (e) {
                                    setDateSelected(e.target.value);
                                } }), _jsx(DateRangeOutlinedIcon, { sx: { position: 'absolute', right: 27, pointerEvents: 'none', color: '#00A190', height: 30, marginTop: 2 } })] }), _jsx("div", { className: "my-4", children: _jsx(TimeSelector, { label: "Start Time", onTimeChange: handleStartTimeChange, initialValue: startTime, lockMinutes: true }) }), _jsx("div", { className: "my-4", children: _jsx(TimeSelector, { label: "End Time", onTimeChange: handleEndTimeChange, initialValue: endTime }) }), _jsx("div", { className: "my-4", children: _jsxs("select", { className: "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors dock-select-ui", value: vesselName, onChange: function (e) {
                                if (e.target.value.trim() == 'YARD') {
                                    setShowShip(false);
                                }
                                else {
                                    setShowShip(true);
                                }
                                setVesselName(e.target.value);
                            }, children: [_jsx("option", { value: "", children: "Select Type of Vessel" }), vesselSuggestions.map(function (vessel, index) { return (_jsx("option", { value: vessel, children: vessel }, vessel + index)); })] }) }), showShip && _jsxs("div", { className: "my-4", children: [_jsx("input", { type: "text", value: shipName, onChange: function (e) { return handleShipNameChange(e.target.value); }, onFocus: function () { return setShowShipSuggestions(true); }, onBlur: function () {
                                    return setTimeout(function () { return setShowShipSuggestions(false); }, 200);
                                }, placeholder: "Enter Ship or select from suggestions", className: "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors", required: true }), showShipSuggestions && (_jsx("div", { className: "absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto", children: shipSuggestions
                                    .filter(function (ship) {
                                    return ship
                                        .toLowerCase()
                                        .includes(shipName.toLowerCase());
                                })
                                    .map(function (ship, index) { return (_jsx("button", { type: "button", onClick: function () { return selectShipSuggestion(ship); }, className: "w-full px-4 py-2 text-left hover:bg-blue-50 transition-colors border-b border-gray-100 last:border-b-0", children: ship }, ship + index)); }) }))] }), _jsxs("div", { className: "my-4", children: [_jsx("input", { id: "header-name", type: "text", value: headerName, onChange: function (e) { return handleHeaderNameChange(e.target.value); }, onFocus: function () { return setShowHeaderSuggestions(true); }, onBlur: function () {
                                    return setTimeout(function () { return setShowHeaderSuggestions(false); }, 200);
                                }, placeholder: "Enter header name or select from suggestions", className: "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors", required: true }), showHeaderSuggestions && (_jsx("div", { className: "absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto", children: headerSuggestions
                                    .filter(function (header) {
                                    return header
                                        .toLowerCase()
                                        .includes(headerName.toLowerCase());
                                })
                                    .map(function (header, index) { return (_jsx("button", { type: "button", onClick: function () {
                                        return selectHeaderSuggestion(header);
                                    }, className: "w-full px-4 py-2 text-left hover:bg-blue-50 transition-colors border-b border-gray-100 last:border-b-0", children: header }, header + index)); }) }))] }), confirmComponent(), _jsx("div", { className: "my-4", children: loading || shipNamesLoading ? (_jsx(Spinner, {})) : (_jsx(PrimaryButton, { title: "Add", classes: "bg-[#00A190] text-white w-full py-2  rounded-[12px]", clickHandle: function () { return chooseAddAction(); } })) }), profileId && (profileId == 622 || profileId == 1161) && (_jsxs("div", { className: "my-2", children: [_jsxs("button", { type: "button", onClick: function () { return voice.isActive ? voice.stop() : voice.start(); }, title: voice.isActive ? "Stop voice assistant" : "Fill form with voice", className: "w-full flex items-center justify-center gap-2 py-2 rounded-[12px] border-2 transition-all duration-200 ".concat(voice.isActive
                                    ? "border-red-400 bg-red-50 text-red-500"
                                    : "border-[#00A190] bg-white text-[#00A190] hover:bg-[#00A190] hover:text-white"), children: [voice.voiceState === "listening" ? (
                                    /* Pulsing mic when listening */
                                    _jsxs("span", { className: "relative flex h-5 w-5 items-center justify-center", children: [_jsx("span", { className: "animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-60" }), _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", className: "relative h-4 w-4", children: _jsx("path", { d: "M12 1a4 4 0 0 1 4 4v6a4 4 0 0 1-8 0V5a4 4 0 0 1 4-4zm-6 10a6 6 0 0 0 12 0h2a8 8 0 0 1-7 7.93V21h-2v-2.07A8 8 0 0 1 4 11h2z" }) })] })) : voice.voiceState === "processing" ? (_jsxs("svg", { className: "animate-spin h-5 w-5", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", children: [_jsx("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }), _jsx("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8v8H4z" })] })) : voice.voiceState === "asking" || voice.voiceState === "confirming" ? (
                                    /* Speaker wave icon */
                                    _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", className: "h-5 w-5", children: _jsx("path", { d: "M13 3.5v17a1 1 0 0 1-1.6.8L5.6 17H2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3.6l5.8-4.3A1 1 0 0 1 13 3.5zm5.5 4.07a7 7 0 0 1 0 8.86l-1.5-1.5a5 5 0 0 0 0-5.86l1.5-1.5z" }) })) : (
                                    /* Default mic icon */
                                    _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", className: "h-5 w-5", children: _jsx("path", { d: "M12 1a4 4 0 0 1 4 4v6a4 4 0 0 1-8 0V5a4 4 0 0 1 4-4zm-6 10a6 6 0 0 0 12 0h2a8 8 0 0 1-7 7.93V21h-2v-2.07A8 8 0 0 1 4 11h2z" }) })), _jsx("span", { className: "text-sm font-medium", children: voice.isActive ? "Stop Voice Input" : "Fill with Voice" })] }), voice.isActive && (_jsxs("div", { className: "mt-2 rounded-lg border border-[#00A19033] bg-[#f0fdfb] px-3 py-2 text-sm text-[#007a6e]", children: [_jsx("p", { className: "font-medium leading-snug", children: voice.statusMessage }), voice.liveTranscript && (_jsxs("p", { className: "mt-1 italic text-gray-500", children: ["\"", voice.liveTranscript, "\""] }))] }))] }))] })] }));
};
export default AddTimeLogs;
